import { render, staticRenderFns } from "./FilesExpedition.vue?vue&type=template&id=fbe9f012&scoped=true"
import script from "./FilesExpedition.vue?vue&type=script&lang=js"
export * from "./FilesExpedition.vue?vue&type=script&lang=js"
import style0 from "./FilesExpedition.vue?vue&type=style&index=0&id=fbe9f012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe9f012",
  null
  
)

export default component.exports